import { createFileRoute } from '@tanstack/react-router';
import { ImageStitchPage } from '@/components/custom/image-stitch-page';
import { getImageStitchSeoData } from '@/components/custom/image-stitch-seo-data';
import { seo } from '@/lib/seo';
import { getImageUrl } from '@/lib/urls';

export const Route = createFileRoute('/image-stitch')({
  head: () => {
    const data = getImageStitchSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
      image: getImageUrl(data.proofImage),
    });
  },
  component: ImageStitchRoute,
});

function ImageStitchRoute() {
  return <ImageStitchPage />;
}
